import * as React from "react";
import { Component } from "react";
import { RouteProps } from "react-router";

export const recursiveMap = (children: React.ReactNode, fn: (child: React.ReactNode) => void): React.ReactNode => {
    return React.Children.map(children, (child) => {
        if (!React.isValidElement(child)) {
            return child;
        }

        if ((child.props as any).children) {
            child = React.cloneElement(child as any, {
                children: recursiveMap((child.props as any).children, fn),
            });
        }

        return fn(child);
    });
};

export const emptyClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    return false;
};

export const extractChildRoutes = (route: Component<RouteProps> | Array<Component<RouteProps>>, prefix?: string) => {
    let paths: RouteProps[] = [];
    const childRoutes: Array<Component<RouteProps>> = !Array.isArray(route)
        ? (route.props && route.props.children ? route.props.children : (route as any).childRoutes)
        : [];

    if (childRoutes) {
        if (Array.isArray(childRoutes)) {
            childRoutes.forEach((r) => {
                paths = paths.concat(extractRoute(r, prefix));
            });
        }
        else
        {
            paths = paths.concat(extractRoute(childRoutes, prefix));
        }
    }
    return paths;
};

export const extractRoute = (route: Component<RouteProps> | Array<Component<RouteProps>>, prefix?: string) => {
    const path: string = !Array.isArray(route)
        ? (route.props && route.props.path ? route.props.path : (route as any).path)
        : undefined;

    let paths: RouteProps[] = [];

    if (!path) {
        if (Array.isArray(route)) {
            route.forEach((r) => {
                paths = paths.concat(extractRoute(r, prefix));
            });

            return paths;
        }
        else
        {
            return extractChildRoutes(route, prefix);
        }
    }

    const currentPath = `${prefix || ""}${path}`.replace(/\/+/g, "/");

    if (!Array.isArray(route)) {
        paths.push({
            ...route.props,
            path: `${currentPath.startsWith("/") ? "" : "/"}${currentPath}`,
        });
        paths = paths.concat(extractChildRoutes(route, `${currentPath}/`));
    }
    return paths;
};

/**
 * Extracts all route props from the given route or route array
 * @param route The route or route array
 * @param [prefix] Optional. Base url prefix
 */
export const extractRouteProps = (route: Component<RouteProps> | Array<Component<RouteProps>>, prefix?: string) => {
    let paths: RouteProps[] = [];
    if (Array.isArray(route)) {
        route.forEach((r) => {
            paths = paths.concat(extractRoute(r, prefix));
        });
    }
    else
    {
        paths = paths.concat(extractRoute(route, prefix));
    }

    return paths;
};



// WEBPACK FOOTER //
// ./src/utils/ReactHelper.ts